import React, { useState } from "react";
import EpicHeader from "./EpicHeader";
import EpicContent from "./EpicContent";
import Header from "./header";
import "../epic.css";
import NotesCont from "../../notes-fhir/container/notesCont";
import TemplateNDicationCont from "../../notes-fhir/container/TemplateNDicationCont";
import { DeleteNote } from "./deletePopup";
import { useInactivity } from "../container/useInactivity";
import { InactivityModal } from "./inactivityModal";

const EpicComp = ({ epicCredDetails, patientDetails, patientId, notesList, getNotes, loader, setLoader }) => {
   const [startRecord, setStartRecord] = useState(false);
   const [noteId, setNoteId] = useState(null);
   const [showButton, setShowButton] = useState(false);
   const [showDeletePopUp, setShowDeletePopup] = useState(false);
   const [showInactivityModal, setShowInactivityModal] = useState(false);
   const stopInactivityTracker = !(!showButton && startRecord);
   useInactivity(
      () => {
         setShowInactivityModal(true);
      },
      stopInactivityTracker,
      600000
   );
   return (
      <div className="parent-epic-container-main-root">
         <div className="py-2">
            <Header
               callback={() => {
                  setStartRecord(false);
                  setShowButton(false);
                  setNoteId(null);
                  getNotes();
               }}
               startRecord={startRecord}
               setStartRecord={setStartRecord}
               setShowButton={setShowButton}
               showButton={showButton}
            />
         </div>
         {startRecord ? (
            <NotesCont
               setShowButton={setShowButton}
               patientDetails={patientDetails}
               stopRecordingMain={(loadContent = true) => {
                  setStartRecord(false);
                  setShowButton(false);
                  setNoteId(null);

                  if (loadContent) {
                     setLoader(true);
                     getNotes();
                  } else {
                     setLoader(true);
                     setTimeout(() => {
                        getNotes();
                     }, 1000);
                  }
               }}
               patientId={patientId}
               jsonRes={epicCredDetails}
            />
         ) : noteId ? (
            <div className="template-dictaion-cont-epic">
               <TemplateNDicationCont
                  setShowDeletePopup={setShowDeletePopup}
                  selectedNoteId={noteId}
                  setNoteId={(id) => {
                     setNoteId(id);
                     getNotes();
                     setStartRecord(false);
                     setShowButton(false);
                  }}
               />
            </div>
         ) : (
            <>
               <div style={{ marginTop: "55px" }} className="d-flex justify-content-center ">
                  <EpicHeader patientDetails={patientDetails} />
               </div>
               <EpicContent
                  setShowDeletePopup={setShowDeletePopup}
                  patientId={patientId}
                  setStartRecord={setStartRecord}
                  getNotes={getNotes}
                  notesList={notesList}
                  setNoteId={(id) => {
                     setNoteId(id);
                  }}
                  loader={loader}
               />
            </>
         )}
         {showDeletePopUp && (
            <DeleteNote
               getNotes={getNotes}
               noteId={showDeletePopUp}
               isDetailsPage={noteId !== null}
               oncompleted={() => {
                  setShowDeletePopup(false);
                  if (noteId) {
                     getNotes();
                     setNoteId(null);
                  } else {
                     getNotes(false);
                     setNoteId(null);
                  }
               }}
               onCancel={() => {
                  setShowDeletePopup(false);
               }}
            />
         )}
         {showInactivityModal && (
            <InactivityModal
               onCancel={() => {
                  setShowInactivityModal(false);
               }}
            />
         )}
      </div>
   );
};

export default EpicComp;
